import React, { useState, useEffect } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { metricsService } from '../../services/metricsService';

export default function AbandonedTab() {
  const [abandonedData, setAbandonedData] = useState(null);
  const [abandonedLoading, setAbandonedLoading] = useState(false);
  const [abandonedError, setAbandonedError] = useState(null);

  const fetchAbandoned = async () => {
    setAbandonedLoading(true);
    setAbandonedError(null);
    try {
      const data = await metricsService.getAbandoned();
      setAbandonedData(data);
    } catch (e) {
      setAbandonedError('Ошибка загрузки данных');
    } finally {
      setAbandonedLoading(false);
    }
  };

  useEffect(() => {
    fetchAbandoned();
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">Брошенные задачи (за 30 дней)</h2>
        <Button variant="outline" onClick={fetchAbandoned} disabled={abandonedLoading}>
          {abandonedLoading ? 'Загрузка...' : 'Обновить'}
        </Button>
      </div>

      {abandonedError && <p className="text-paper-accent">{abandonedError}</p>}

      {abandonedLoading && !abandonedData && (
        <div className="flex justify-center py-20">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-paper-accent" />
        </div>
      )}

      {abandonedData && (() => {
        const services = [...new Set(abandonedData.buckets.flatMap(b => Object.keys(b.by_service)))].sort();
        const totalByService = services.reduce((acc, svc) => {
          acc[svc] = abandonedData.buckets.reduce((s, b) => s + (b.by_service[svc] || 0), 0);
          return acc;
        }, {});

        return (
          <>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <div className="bg-paper-accent/[0.06] p-4 rounded-panel text-center">
                <p className="text-sm text-paper-ink-3">Всего брошено</p>
                <p className="text-2xl font-bold text-paper-accent">{abandonedData.total}</p>
              </div>
              {services.map(svc => (
                <div key={svc} className="bg-paper-panel p-4 rounded text-center">
                  <p className="text-sm text-paper-ink-3">{svc.replace('bit-', '')}</p>
                  <p className="text-2xl font-bold">{totalByService[svc]}</p>
                </div>
              ))}
            </div>

            <Card className="overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-paper-panel border-b text-left">
                      <th className="px-3 py-2.5 font-medium text-paper-ink-3">Дата</th>
                      <th className="px-3 py-2.5 font-medium text-paper-ink-3">Всего</th>
                      {services.map(svc => (
                        <th key={svc} className="px-3 py-2.5 font-medium text-paper-ink-3">{svc.replace('bit-', '')}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[...abandonedData.buckets].reverse().map((row, i) => (
                      <tr key={i} className="border-b hover:bg-paper-panel">
                        <td className="px-3 py-2.5">{row.date}</td>
                        <td className="px-3 py-2.5 font-medium text-paper-accent">{row.total}</td>
                        {services.map(svc => (
                          <td key={svc} className="px-3 py-2.5 text-paper-ink-3">
                            {row.by_service[svc] || '—'}
                          </td>
                        ))}
                      </tr>
                    ))}
                    {abandonedData.buckets.length === 0 && (
                      <tr><td colSpan={2 + services.length} className="px-3 py-8 text-center text-paper-hint">Нет данных</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Card>
          </>
        );
      })()}
    </div>
  );
}
